export default __webpack_public_path__ + "static/media/favicon_rm.c060ada2.ico";